import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-aspsyllabus',
  templateUrl: './aspsyllabus.component.html',
  styleUrls: ['./aspsyllabus.component.scss']
})
export class AspsyllabusComponent implements OnInit {

  constructor() { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
